import axios from 'axios'

const DEFAULT_DASHBOARD_CONFIG = {
    message: "Success",
    res: 1,
    result: {
        filters: {
            destname: true,
            endtime: true,
            srcname: true,
            starttime: true,
            transporter: true
        },
        user_data: {},
        views: {
            breach_report: false,
            covid_summary: false,
            halt_overview: true,
            heatmap: true,
            overview: true,
            quarantine_status: false,
            sct_delay: true,
            sct_eta: true,
            sct_summary: true
        }
    },
    status: true
}

export const authService = {

    login( credentials ) {
        return axios.post('https://sct.intutrack.com/api/test/login', {}, {
            auth: credentials,
            headers: {
                'x-request-source': 'web-ui'
            }
        })
    },
    validateToken( token, user = {} ){
        return Promise.resolve({
            data: {
                ...DEFAULT_DASHBOARD_CONFIG,
                result: {
                    ...DEFAULT_DASHBOARD_CONFIG.result,
                    user_data: {
                        ...DEFAULT_DASHBOARD_CONFIG.result.user_data,
                        token,
                        user: user.username,
                        client: user.username,
                        priviledge: user.priviledge,
                        email: user.email,
                        _id: user._id,
                    }
                }
            }
        })
    }
}
